import React from 'react';

import { CoachMarkProvider } from '../../components/CoachMark';
import CookieConsent from '../../components/CookieConsent';
import ClarityLoader from '../../components/ClarityLoader';
import GoogleAnalyticsLoader from '../../components/GoogleAnalyticsLoader';
import MetaPixelLoader from '../../components/MetaPixelLoader';
import ScriptManager from '../../components/ScriptManager';
import { ThemeProvider } from '../../contexts/ThemeContext';
import { CreditProvider } from '../../hooks/useCreditSystem';
import { ErrorBoundary } from '../../shared/components/feedback';

interface AppProvidersProps {
  children: React.ReactNode;
}

const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <CreditProvider>
          <CoachMarkProvider>
            {children}

            {/* Global Components */}
            <ScriptManager />
            <CookieConsent />
            <MetaPixelLoader />
            <ClarityLoader />
            <GoogleAnalyticsLoader />
          </CoachMarkProvider>
        </CreditProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default AppProviders;
